<div class="sort-placeholder">
  <kendo-svg-icon *ngIf="(sort | findSort:field) && ((sort | findSort:field).dir === 'asc')" [icon]="ApKendoIconService.Get('sortAscSmallIcon')"></kendo-svg-icon>
  <kendo-svg-icon  *ngIf="(sort | findSort:field) && ((sort | findSort:field).dir === 'desc')" [icon]="ApKendoIconService.Get('sortDescSmallIcon')"></kendo-svg-icon>
</div>
